import { ProjectTitleInput } from '@photosi/rn-components/project/project-title-input/ProjectTitleInput';
import { View } from 'react-native';
import { styles } from './PressTooltipContent.styles';
import { ProjectTitleInputProps } from '@photosi/rn-components/project/project-title-input/ProjectTitleInput.types';

export const PressTooltipContent = ({
  focusId,
  focusOrder,
  focusGroup,
}: Pick<ProjectTitleInputProps, 'focusId' | 'focusOrder' | 'focusGroup'>) => {
  return (
    <View style={styles.pressTooltipContentWrapper}>
      <ProjectTitleInput focusId={focusId} focusOrder={focusOrder} focusGroup={focusGroup} />
    </View>
  );
};
